import { HotToastService } from "@ngneat/hot-toast";
import {
  Component,
  OnInit,
  PACKAGE_ROOT_URL,
  TemplateRef,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DashboardService } from "../../dashboard.service";
import { AccountantService } from "../accountant/accountant.service";
import { Subscription } from "rxjs";
import { DragulaService, DragulaModule } from "ng2-dragula";
import * as _ from "underscore";
import { AppSearchPipe } from "../common/apps.pipes";
import { FormsModule } from "@angular/forms";
import { AppsItemComponent } from "../common/apps-item.component";
import { NgIf, NgFor, NgClass } from "@angular/common";


/**
 * Dashboard main page component. It's empty for now
 */
@Component({
    selector: "app-apps-panel-widget",
    templateUrl: "./apps-panel.component.html",
    styleUrls: ["../common/apps.component.css"],
    imports: [
    NgIf,
    NgFor,
    AppsItemComponent,
    DragulaModule,
    FormsModule,
    NgClass,
    AppSearchPipe
]
})
export class AppsPanelWidgetComponent implements OnInit, OnChanges {
  @Input() preview = false;
  @Input() isForDefault = false;
  _company: any;

  @Input()
  set company(value: any) {
    if (value !== undefined) {
      this._company = value;

      // Update client and apps variables
      this.current_client = this._company;

      if (this._company.apps != null) {
        this.company_apps = this._company.apps;
      }

      this.change_library("global");
    }
  }

  @Input()
  set apps(value: any) {
    this._company.apps = value;

    if (this._company.apps != null) {
      this.company_apps = this._company.apps;
    }
    this.change_library("global");
  }

  public modalRef: BsModalRef;
  user: any;
  data: any;

  // Store global resources from /resource when ACCOUNTANT
  global_apps: any = [];
  // Store company specific resources from /resource when ACCOUNTANT
  practice_apps: any = [];
  // Store company specific resources from /resource when CLIENT
  company_apps: any = [];

  fixed_global_apps: any = [];
  fixed_practice_apps: any = [];

  innerWidth: any;

  current_library = { name: "Global Library", bucket: this.global_apps };

  current_client: any = {};
  showAddApp: any;
  clientSubscription: Subscription;

  search = "";
  sort_type = "Order";

  dragulaOptions: any = {
    direction: "horizontal",
  };

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
  };

  subs = new Subscription();

  constructor(
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private dashboardService: DashboardService,
    private accountantService: AccountantService,
    private dragulaService: DragulaService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.showAddApp = false;

    this.innerWidth = window.screen.width;

    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    // this.company = this.localStorage.get("company");

    if (this.innerWidth < 600) {
      this.slideConfig = {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
      };
    }

    this.dragulaService.createGroup("bag-apps-client-panel", {
      direction: "horizontal",
    });

    this.dashboardService.get_apps().then((res: any) => {
      const response = res;
      this.global_apps = response.global_apps;
      this.fixed_global_apps = response.global_apps;
      this.practice_apps = response.practice_apps;
      this.fixed_practice_apps = response.practice_apps;

      this.current_library = {
        name: "Global Library",
        bucket: this.global_apps,
      };
    });

    // Subscription to the drop event from dragula. Used to calculate the order and update it
    // in the backend
    this.dragulaService
      .drop("bag-apps-client-panel")
      .subscribe(({ name, el, target, source, sibling }) => {
        if (name === "bag-apps-client-panel") {
          let order = 0;
          this.company_apps.forEach((v) => {
            v.order = order;
            order++;
          });

          this.accountantService
            .update_company_app_order(this.current_client.id, this.company_apps)
            .then(
              (res: any) => {
                const response = res;
              },
              (err) => {
                console.log(err);
              }
            );
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {}

  public openModal(template: TemplateRef<any>) {
    this.showAddApp = false;
    this.modalRef = this.modalService.show(template, { class: "modal-lg" });
  }

  add_company_app(app, index): void {
    if (this.isForDefault) {
      this.add_company_default_app(app, index);
      return;
    }
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .add_company_app(this.current_client.id, app.id)
      .then((res: any) => {
        const response = res;
        console.log("Added company app", response);
        app.order = response.order;
        app.company_app_id = response.company_app_id;
        this.company_apps.push(app);
        this.current_library.bucket.splice(index, 1);
        this.dashboardService.show_loading.next(false);
      });
  }

  delete_company_app(app, index): void {
    if (this.isForDefault) {
      this.delete_company_default_app(app, index);
      return;
    }
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .delete_company_app(this.current_client.id, app.id)
      .then((res: any) => {
        if (app.company == null) {
          this.current_library.bucket.push(app);
        } else {
          if (this.current_library.name === "Practice Library") {
            this.current_library.bucket.push(app);
          } else {
            this.practice_apps.push(app);
          }
        }

        this.company_apps.splice(index, 1);
        this.dashboardService.show_loading.next(false);
      });
  }

  change_library(type): void {
    if (type === "global") {
      // Calculate the differences between the full list and the client list
      // so it only shows in the complete list the apps that user doesnt hav
      this.global_apps = _.filter(this.fixed_global_apps, (obj: any) => {
        return !_.findWhere(this.company_apps, { id: obj.id });
      });

      this.current_library.bucket = this.global_apps;
      this.current_library.name = "Global Library";
    } else if (type === "practice") {
      // Calculate the differences between the full list and the client list
      // so it only shows in the complete list the apps that user doesnt hav
      this.practice_apps = _.filter(this.fixed_practice_apps, (obj: any) => {
        return !_.findWhere(this.company_apps, { id: obj.id });
      });

      this.current_library.bucket = this.practice_apps;
      this.current_library.name = "Practice Library";
    }
  }

  ngOnDestroy() {
    this.dragulaService.destroy("bag-apps-client-panel");
  }

  add_company_default_app(app, index) {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .add_company_default_app(app.id)
      .then(({ order, company_id }: any) => {
        app.order = order;
        app.company_app_id = company_id;
        this.company_apps.push(app);
        this.current_library.bucket.splice(index, 1);
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Default app added successfully");
      });
  }

  delete_company_default_app(app, index) {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .delete_company_default_app(app.id)
      .then((res: any) => {
        if (app.company == null) {
          this.current_library.bucket.push(app);
        } else {
          if (this.current_library.name === "Practice Library") {
            this.current_library.bucket.push(app);
          } else {
            this.practice_apps.push(app);
          }
        }
        this.company_apps.splice(index, 1);
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Default app deleted successfully");
      });
  }
}
